import React from 'react';
import styled from '@benzinga/themetron';
import { Icon } from '@benzinga/core-ui';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';

interface Menu {
  header: string;
  subnav: {
    links: { href: string; label: string; title: string }[];
  };
}

export interface SidebarMenuProps {
  activeTab?: string;
  menus: Menu[];
  onClickTab?: (link: { href: string; label: string; title: string }) => void;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({ activeTab, menus, onClickTab }) => {
  const isActive = (link: string) => link && link === activeTab;

  return (
    <Container className="sidebar-menu-block-container">
      {menus.map(menu => (
        <div key={menu.header}>
          <div className="sidebar-menu-block-header">{menu.header}</div>
          <ul className="sidebar-menu-block-list">
            {menu.subnav.links.map(link => (
              <li
                className={`${isActive(link.href) ? 'active' : ''}`}
                key={link.title}
                onClick={() => onClickTab && onClickTab(link)}
              >
                {isActive(link.href) && <Icon className="active" icon={faCaretRight} />}
                {onClickTab ? (
                  <span className="tab-title">{link.title}</span>
                ) : (
                  <a className="tab-title" href={link.href}>
                    {link.title}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </Container>
  );
};

const Container = styled.div`
  &.sidebar-menu-block-container {
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    width: 100%;
    height: fit-content;

    .sidebar-menu-block-header {
      background-color: #003054;
      color: #fff;
      padding: 5px 12px;
    }

    .sidebar-menu-block-list {
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          background-color: #999999;
        }

        &.active {
          .tab-title {
            padding-left: 0;
            text-decoration: underline;
          }
        }

        .active {
          color: ${({ theme }) => theme.colorPalette.blue500};
          margin-right: 2px;
        }

        .tab-title {
          display: block;
          width: 100%;
          height: 100%;
          padding: 5px 12px;
          padding-right: 10px;
          color: ${({ theme }) => theme.colorPalette.black};

          &:hover {
            color: ${({ theme }) => theme.colorPalette.white};
            text-decoration: underline;
          }
        }
      }
    }
  }
`;
